export enum LogisticsTenant {
    RIO = 'vw.rio-dev',
    VW_QA = 'vw.qa',
    VW = 'vw.prod',
}

const isValidLogisticsTenantFromToken = (value: unknown): value is LogisticsTenant =>
    Object.values(LogisticsTenant).some((v) => v === value);

export const getStrictLogisticsTenantFromToken = (value: unknown) => {
    return isValidLogisticsTenantFromToken(value) ? (value as LogisticsTenant) : undefined;
};
